import cn from 'classnames'
import React from 'react'
import styles from './marker.module.css'

export interface MarkerProps {
  className?: string
}

export const Marker = React.forwardRef<HTMLDivElement, MarkerProps>((props, ref) => {
  const { className } = props

  /** Update the marker */
  return <div className={cn(styles.marker, className)} ref={ref} />
})

export default Marker
